import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  LoadingIndicator,
} from '@commenda/kakashi';
import React from 'react';
import Cropper, { Area } from 'react-easy-crop';
import { getCroppedBase64 } from './helpers';

type Props = {
  srcDataUrl: string;
  onCancel: () => void;
  onCropped: (base64: string) => void;
};

export const AvatarCropDialog = ({ srcDataUrl, onCancel, onCropped }: Props) => {
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [zoom, setZoom] = React.useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState<Area | null>(
    null
  );
  const [isSaving, setIsSaving] = React.useState(false);

  const handleSave = async () => {
    if (!croppedAreaPixels) return;
    setIsSaving(true);
    try {
      const base64 = await getCroppedBase64(srcDataUrl, croppedAreaPixels);
      onCropped(base64);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Crop your photo</DialogTitle>
        </DialogHeader>
        <div className="relative w-full h-80 bg-neutral-1">
          <Cropper
            image={srcDataUrl}
            crop={crop}
            zoom={zoom}
            aspect={1}
            cropShape="round"
            showGrid={false}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={(_, pixels) => setCroppedAreaPixels(pixels)}
          />
        </div>
        <div className="px-6 py-4">
          <input
            type="range"
            min={1}
            max={3}
            step={0.01}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            className="w-full"
            aria-label="Zoom"
          />
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={onCancel} type="button">
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            type="button"
            disabled={isSaving || !croppedAreaPixels}
          >
            {isSaving ? <LoadingIndicator /> : 'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
